<div class="card mb-0 main-card overflow-auto">
  <div class="card-header">
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="card-title align-items-center d-flex p-0">
        Patients
        <span class="badge text-dark bg-body-secondary ms-2">{{ TotalPatients }}</span>
      </h5>
      <div class="d-flex">
        <div class="search-bar">
          <div class="form-group">
            <div class="input-group has-prefix">
              <i class="prefix bi bi-search"></i>
              <input type="text" class="form-control" name="query" placeholder="Search Patient" title="Search Patient" (keyup)="SearchData()" [(ngModel)]="SearchVal" />
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addPatientModal" (click)="OpenAddPopup()"><i class="bi bi-plus"></i> Add Patient</button>
      </div>
    </div>
  </div>
  <div class="card-body p-0">
    <div class="table-responsive h-100">
      <table class="table table-hover table-x-padding mb-0" *ngIf="TotalPatients || IsLoading">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">PID</th>
            <th scope="col">
              <button
                class="btn btn-sm p-0 btn-sort"
                (click)="SortData('firstName')"
                [ngClass]="this.PaginationParams.sortColumn === 'firstName' ? this.PaginationParams.sortOrder : ''"
                [disabled]="IsLoading"
              >
                Patient Name
                <i class="text-body-tertiary bi-arrow-down-short"></i>
              </button>
            </th>
            <th scope="col">Date of Birth</th>
            <th scope="col">Phone</th>
            <th scope="col">D/A</th>
            <th scope="col">D/E</th>
            <th scope="col">Case Type</th>
            <th scope="col">Attorney</th>
            <th scope="col">Disabled</th>
            <th scope="col">Transportation</th>
            <th scope="col">OV/W</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="!IsLoading">
            <tr *ngFor="let patient of patientsList; index as i">
              <th scope="row">{{ i + 1 + PaginationParams.skip }}</th>
              <th scope="row">#{{ patient.id }}</th>
              <td>{{ patient.lastName }} {{ patient.firstName }}</td>
              <td>{{ patient.dateOfBirth | date : 'MM/dd/yyyy' }}</td>
              <td>{{ patient.phoneNumber | phonenumber : 'format' }}</td>
              <td>{{ patient.dateOfAccident | date : 'MM/dd/yyyy' }}</td>
              <td>{{ patient.dateOfEntry | date : 'MM/dd/yyyy' }}</td>
              <td>{{ patient.caseName }}</td>
              <td>{{ patient.attorneyName }}</td>
              <td><i class="bi fs-5" [ngClass]="{ 'bi-person-wheelchair': patient.disabled }"></i></td>
              <td>{{ patient.transportation }}</td>
              <td>{{ patient.oV_W }}</td>
              <td>
                <button type="button" class="btn btn-sm" (click)="OpenApptDialogue(patient)">
                  <i class="bi bi-calendar2-plus fs-5"></i>
                </button>
                <button type="button" class="btn btn-sm" data-bs-toggle="modal" data-bs-target="#addPatientModal" (click)="OpenEditPopup(patient.id)" *ngIf="patient.id">
                  <i class="bi bi-pencil-square fs-5"></i>
                </button>
              </td>
            </tr>
          </ng-container>

          <ng-container *ngIf="IsLoading">
            <tr *ngFor="let employee of ['', '', '', '', '']; index as i">
              <td *ngFor="let employee of ['', '', '', '', '', '', '', '', '', '', '', '', '']; index as i">
                <p class="placeholder-glow">
                  <span class="placeholder col-12"></span>
                </p>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <div class="empty-data-placeholder" *ngIf="!TotalPatients && !IsLoading">
        <div class="text-center">
          <h3 class="text-body-tertiary"><i class="bi bi-exclamation-triangle"></i> Oops..!</h3>
          <p>No Patients Found</p>
        </div>
      </div>
    </div>
  </div>

  <div class="card-footer" *ngIf="TotalPatients">
    <div class="d-flex justify-content-between">
      <button class="btn" (click)="GetDischargedPatientsList(!ShowDischargedPatients)" [ngClass]="!ShowDischargedPatients ? 'btn-danger' : 'btn-primary'">
        Show {{ !ShowDischargedPatients ? 'Discharged' : 'Regular' }} Patients
      </button>
      <app-pagination [totalItems]="TotalPatients" [pageSize]="PaginationParams.take" (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)" />
    </div>
  </div>
</div>
